<template>
 <div style="padding: 20px">
    <div class="handle-box" style="display:flex;flex-wrap: wrap;margin-bottom: 20px">
      <el-button type="primary" style="margin-right: 10px" @click="$refs.create.openDialog()">新增</el-button>

      <el-select placeholder="榜单" style="width: 120px;" v-model="query.type">
        <div>
          <el-option label="最强新人榜" value="1"></el-option>
          <el-option label="焱火英雄榜" value="2"></el-option>
          <el-option label="区域英雄榜" value="3"></el-option>
        </div>
      </el-select>
      <el-date-picker type="month" style="width:170px;margin-left: 10px" value-format="YYYY/MM" v-model="query.date"
                      placeholder="请选择">
      </el-date-picker>
      <el-button type="primary" style="margin-left: 10px" @click="getPageList">搜索</el-button>
      <el-button type="primary" style="margin-left: 10px" @click="importDialog = true">导入</el-button>
    </div>
   <el-table
       :data="tableData"
       height="590px"
       border
       class="table"
       ref="multipleTable"
       header-cell-class-name="table-header">
     <el-table-column label="ID" align="center" show-overflow-tooltip prop="id" width="100"/>
     <el-table-column label="姓名" align="center" show-overflow-tooltip prop="coachName" width="100"/>
     <el-table-column label="榜单" align="center" width="120">
       <template #default="scope">
         <span v-if="scope.row.type === 1">最强新人榜</span>
         <span v-if="scope.row.type === 2">焱火英雄榜</span>
         <span v-if="scope.row.type === 3">区域英雄榜</span>
       </template>
     </el-table-column>
     <el-table-column prop="title" show-overflow-tooltip label="类型" width="200" align="center"/>
     <el-table-column prop="introduce" show-overflow-tooltip label="经历" width="200" align="center"/>
     <el-table-column prop="saying" show-overflow-tooltip label="格言" width="200" align="center"/>
     <el-table-column prop="honoraryTitle" show-overflow-tooltip label="荣誉历程" width="200" align="center"/>
     <el-table-column show-overflow-tooltip="true" prop="addTime"  width="140" label="图片">
       <template #default="scope">
       <el-image style="width: 100px; height: 60px" :src="scope.row.heroUrl" fit="concat" :preview-src-list="[scope.row.heroUrl]" />
       </template>
     </el-table-column>
     <el-table-column show-overflow-tooltip="true" prop="addTime" label="添加时间"></el-table-column>
     <el-table-column fixed="right" label="操作" width="100" align="center">
       <template #default="scope">
         <el-button text type="primary" style="width: 14px;" size="small" @click="$refs.update.openDialog(scope.row)">编辑</el-button>
         <el-popconfirm @confirm="deleteHonor(scope.row.id)" title="确定要删除吗？">
           <template #reference>
             <el-button text type="primary" style="width: 14px;color: red" size="small">删除</el-button>
           </template>
         </el-popconfirm>
       </template>
     </el-table-column>
   </el-table>
   <el-dialog v-model="importDialog" title="导入表格" width="700">
     <div  v-loading="importLoading">
       <el-form :model="importData" ref="importRules" label-width="100px" class="demo-ruleForm">
         <el-row>
           <el-col :span="11">
             <el-form-item label="所属榜单" prop="type" :rules="{ required: true, message: '请选择', trigger: 'blur'}">
               <el-select placeholder="请选择" style="width: 170px;" v-model="importData.type">
                 <div>
                   <el-option label="最强新人榜" value="1"></el-option>
                   <el-option label="焱火英雄榜" value="2"></el-option>
                   <el-option label="区域英雄榜" value="3"></el-option>
                 </div>
               </el-select>
             </el-form-item>
           </el-col>
           <el-col :span="11">
             <el-form-item label="所属月份" prop="date" :rules="{ required: true, message: '请选择', trigger: 'blur'}">
               <el-date-picker type="month" style="width:170px" value-format="YYYY/MM" v-model="importData.date"
                               placeholder="请选择">
               </el-date-picker>
             </el-form-item>
           </el-col>
         </el-row>
         <el-row>
           <el-col :span="22">
             <el-form-item label="文件" prop="file" :rules="{ required: true, message: '请选择', trigger: 'blur'}">
              <el-upload
                 style="width: 470px"
                 drag :limit="1" accept=".xls , .xlsx"
                 :http-request="response => uploadFile(response,index)">
               <el-icon class="el-icon--upload"><upload-filled /></el-icon>
                <div class="el-upload__text">
                 将文件拖到此处，或<em>点击上传。</em>
                </div>
             </el-upload>
             </el-form-item>
           </el-col>
         </el-row>
       </el-form>
     </div>
     <div> <el-link style="color: #1da1f2"
                    href="http://123.14.95.212:9000/contract/studentContract/20260223030333ErNGtomA.xlsx"
                    target="_blank"
                    underline="hover">
       下载导入模板
     </el-link></div>
     <template #footer>
       <div class="dialog-footer">
         <el-button @click="insertDialog = false">取 消</el-button>
         <el-button type="primary" :disabled="importLoading" @click="importFile">确 定</el-button>
       </div>
     </template>
   </el-dialog>
   <div class="pagination">
     <el-pagination
         background
         layout="sizes, prev, pager, next, total"
         :current-page="query.pageIndex"
         :page-size="query.pageSize"
         :page-sizes="[10, 20, 30, 40]"
         :total="query.pageTotal"
         @current-change="handlePageChange"
         @size-change="handlePageSizeChange"
     ></el-pagination>
   </div>
   <create-honor ref="create" @success="getPageList"/>
   <update-honor ref="update" @success="getPageList"/>
  </div>
</template>

<script>

import CreateHonor from "./CreateHonor";
import UpdateHonor from "./UpdateHonor";
import {getPageList,deleteHonor,importHeroRank} from "@/api/coach"
export default {
  components:{
    CreateHonor,UpdateHonor
  },
  name: "Honor",
  data() {
    return {
      importData:{
        date:null,
        file:null,
        type:null,
      },
      importLoading:false,
      importDialog:false,
      query:{
        date:null,
        pageIndex: 1,
        pageSize: 13,
        pageTotal:0
      },
      tableData:[]
    }
  },
  methods: {
    handlePageChange(index){
      this.query.pageIndex=index;
      this.getPageList();
    },
    handlePageSizeChange(size){
      this.query.pageSize=size;
      this.getPageList();
    },
    getPageList(){
      if (this.query.date!=null){
        const [year, month] = this.query.date.split('/');
        this.query.year = year;
        this.query.month = month;
      }else {
        this.query.year = null;
        this.query.month = null;
      }
      getPageList(this.query).then(val=>{
        if (val.code == 200){
          this.query.pageTotal = val.data.total;
          this.tableData = val.data.records;
        }
      })
    },
    uploadFile(val){
      this.importData.file = val.file;
    },
    importFile(){
      this.$refs['importRules'].validate(async (valid) => {
        if (!valid){return;}
        this.importLoading = true;
        const data = new FormData();
        const [year, month] = this.importData.date.split('/');
        data.append('file', this.importData.file);
        data.append('year', year)
        data.append('month', month)
        data.append('type', this.importData.type);
        importHeroRank(data).then(val=>{
          this.importLoading = false;
          if (val.code == 200) {
            this.getPageList();
            this.importDialog = false;
            this.$message.success("文件导入成功！");
          } else {
            this.$message.error("文件导入失败！");
          }
        })
      })

    },
    deleteHonor(id){
      deleteHonor(id).then(val=>{
        if (val.code == 200) {
          this.getPageList();
          this.$message.success("删除成功！");
        } else {
          this.$message.error("删除失败！");
        }
      })
    }
  },
  created() {
    this.getPageList();
  }
}
</script>

<style type="less">
/* CJL TEST
1.重写plus的image图片预览大图的的position定位样式为static !important;
2.需在el-table中手动添加要覆盖的class名 如el-table__cell
3.此css代码需放在全局的less的style节点中 */
.el-table__cell {
  position: static !important;
}
</style>
